import ExtendableError from './ExtendableError';

function selectDefined(...params) {
  return params.find(it => (typeof it !== 'undefined'));
}

/*
  Create a client error from server's app error responses
 */
export default class AppError extends ExtendableError {
  static resolveErrorCode(response) {
    return selectDefined(response.errorCode, 'unspecified');
  }

  constructor(
    message,
    response,
    status = 0,
    timeoutInfo = false
  ) {
    super(message);

    if (response) {
      this.errorCode = selectDefined(response.errorCode, 'unspecified');
      this.serverMessage = selectDefined(response.description, response.statusText);
      this.extra = selectDefined(response.data, response);
      this.requestProcessingStatus = selectDefined(response.requestProcessingStatus, '');
      this.status = status;
    } else {
      if (timeoutInfo) {
        this.errorCode = 'timeout';
        this.serverMessage = 'Request timed out!';
        this.extra = { timeoutInfo };
      } else {
        this.errorCode = 'unspecified';
        this.serverMessage = 'No response from server';
        this.extra = null;
      }

      this.requestProcessingStatus = '';
      this.status = status;
    }
  }

  toJSON() {
    return {
      errorCode: this.errorCode,
      description: this.message,
      serverMessage: this.serverMessage,
      extra: this.extra,
      requestProcessingStatus: this.requestProcessingStatus,
      status: this.status
    };
  }
}
